import { render, staticRenderFns } from "./roomtu.vue?vue&type=template&id=c400d0a4&scoped=true"
import script from "./roomtu.vue?vue&type=script&lang=js"
export * from "./roomtu.vue?vue&type=script&lang=js"
import style0 from "./roomtu.vue?vue&type=style&index=0&id=c400d0a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c400d0a4",
  null
  
)

export default component.exports